import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { MediaItemImage } from '@/features/media/components/MediaItemImage';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    image: {
      width: '100%',
      aspectRatio: 4 / 3,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    },
    placeholder: { backgroundColor: theme.colors.surfaceContainerLow }
  });

export const PostCardCompactThumbnail: FC = () => {
  const { images, isBlocked } = usePostCard();
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const mediaItem = isBlocked ? undefined : images?.[0];

  if (!mediaItem) {
    return <View style={[styles.image, styles.placeholder]} />;
  }

  return (
    <MediaItemImage
      style={styles.image}
      mediaItem={mediaItem}
      mediaSize={MediaItemSize.SMALL}
    />
  );
};
PostCardCompactThumbnail.displayName = 'PostCardCompactThumbnail';
